<template>
  <div id="app">
    <step-transition>
      <component
        :is="currentStep"
        :key="currentStep">
      </component>
    </step-transition>
  </div>
</template>

<script>
import StepTransition from '@shared/components/StepTransition'
import { mapGetters } from 'vuex'

import Intro from './views/Intro'
import PrimeQuizz from './views/PrimeQuizz'
import Outro from './views/Outro'
import Infography from './views/Infography'
import scrollHelper from '@shared/utils/scrollHelper'

export default {
  name: 'App',
  components: {
    StepTransition,
    intro: Intro,
    infography: Infography,
    quizz: PrimeQuizz,
    outro: Outro
  },
  computed: {
    ...mapGetters(['currentStep'])
  },
  mounted () {
    this.$store.dispatch('init')
    scrollHelper.init()
  }
}
</script>

<style lang="scss">
  @import "../shared/styles/globals";
</style>
